import { render, staticRenderFns } from "./PlayerAction.vue?vue&type=template&id=11fcefb6&"
import script from "./PlayerAction.vue?vue&type=script&lang=js&"
export * from "./PlayerAction.vue?vue&type=script&lang=js&"
import style0 from "./PlayerAction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../landing-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
